"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var keyboard = require("../../../_Core/Keyboard");
var Icons_1 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var UpdatePhotoOverlay_styles_1 = require("./UpdatePhotoOverlay.styles");
exports.default = React.forwardRef(function (_a, ref) {
    var IsFullSize = _a.IsFullSize, Size = _a.Size, ActualSize = _a.ActualSize, Show = _a.Show, OnUploadClick = _a.OnUploadClick;
    var _b = React.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var handleOnClick = function (e) {
        e.stopPropagation();
        if (OnUploadClick) {
            OnUploadClick();
        }
    };
    var handleOnKeyPress = function (e) {
        e.stopPropagation();
        var target = e.target;
        if (keyboard.IsSpace(e) || keyboard.IsEnter(e)) {
            target.click();
        }
    };
    return (React.createElement(UpdatePhotoOverlay_styles_1.ContainerDiv, { ref: ref, role: "button", tabIndex: 0, "aria-label": Localization_1.strings.Thumbnail_Action_Update, IsFullSize: IsFullSize, Size: ActualSize, Show: Show || isFocused, onClick: handleOnClick, onKeyPress: handleOnKeyPress, onFocus: function () { return setIsFocused(true); }, onBlur: function () { return setIsFocused(false); } },
        React.createElement(UpdatePhotoOverlay_styles_1.ContentDiv, { IsFullSize: IsFullSize, IsLargest: Size === "Largest", ActualSize: ActualSize },
            React.createElement(Icons_1.CameraIcon, null),
            (Size === "Largest" || IsFullSize) &&
                React.createElement(React.Fragment, null, Localization_1.strings.Thumbnail_Action_Update))));
});
